<script setup lang="ts">
import { Dialog, DialogContent, DialogTitle } from '~/components/ui/dialog'
import { ContentEditor } from '~/components/ui/content'
import type { ICustomConsent } from '~/types'

defineProps<{
  consent: ICustomConsent
}>()

const isOpen = ref(false)
</script>

<template>
  <!-- prevent keeps the click from toggling the checkbox of the parent label -->
  <button type="button" class="text-left text-blue-600 underline" @click.prevent="isOpen = true">
    {{ consent.title }}
  </button>

  <Dialog v-model:open="isOpen">
    <DialogContent
      class="flex h-full max-h-screen w-full flex-col gap-0 rounded-none p-0 sm:h-auto sm:max-h-[90vh] sm:max-w-[min(64rem,100%)] sm:rounded-lg"
    >
      <div class="border-b px-6 py-4 pr-12">
        <DialogTitle>{{ consent.title }}</DialogTitle>
      </div>

      <div class="flex-1 overflow-y-auto px-6 py-4 text-sm leading-relaxed text-gray-700">
        <ContentEditor :html="consent.html" />
      </div>
    </DialogContent>
  </Dialog>
</template>
